import "./Share.scoped.scss";
import React from "react";
import { Link } from "react-router-dom";
import { PopupShare, Service_CN } from "../../../utils/CommonFunc";
import { isOpenShareState } from "../../../atoms/atom";
import { useRecoilValue } from "recoil";
import { ILoungeInfo } from "../../../api/api";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faClone } from "@fortawesome/free-solid-svg-icons";
import { isLauncherState } from "../../../atoms/userInfoAtom";

interface IProps {
  data: ILoungeInfo;
  len?: string | undefined;
}

function Share(props: IProps) {
  const { t } = useTranslation();
  const { data, len } = props;
  const isOpenShare = useRecoilValue(isOpenShareState);
  const sns = data.data.sns.split("|").map((i) => i.toLowerCase());
  const isLauncher = useRecoilValue(isLauncherState);

  const onCopy = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      alert(t("Link_copied"));
      return true;
    } catch (error) {
      alert(t("Link_copying_is_not_possible"));
      return false;
    }
  };

  return isOpenShare ? (
    <span className={`shareComponent ${len === "short" ? " on" : ""}`}>
      {sns.length !== 0
        ? sns.map((i: string, idx: number) => (
            <span className="Share-item" key={idx}>
              <Link
                to="#"
                onClick={(e) =>
                  PopupShare(i, window.location.href, sns[idx], isLauncher)
                }
                className={`sharebtns btn-${i}`}
              />
            </span>
          ))
        : null}
      {/* <span
        className="Share-item fa-light fa-clone"
        onClick={() => onCopy(window.location.href)}
      /> */}
      {Service_CN ? null : (
        <FontAwesomeIcon
          icon={faClone as IconProp}
          className="Share-item "
          onClick={() => onCopy(window.location.href)}
        />
      )}
    </span>
  ) : null;
}

export default Share;
